// import { useState } from "react";
import { Button } from "../../../components";
// import ExamFeedback from "./ExamFeedback";
// import SuccessFeedback from "../../../components/popup/SuccessFeedback";
import { auth } from "../../../config/firebaseConfig";
import envConfig from "../../../config/envConfig";

const SubmitModule = ({ name }) => {
  // const [showFeedbackView, setshowFeedbackView] = useState(false);
  // const [successDialog, setSuccessDialog] = useState(false);

  // const closeFeedback = () => {
  //   setshowFeedbackView(false);
  // };
  // const showSuccessDialog = () => {
  //   setSuccessDialog(true);
  // };

  const resultDate = "10 Oct 2024";
  const website = envConfig.appUrl;

  return (
    <div className="w-full h-full bg-[#001E3B] text-white">
      <div className="w-full h-full flex flex-col items-center justify-center gap-8 relative">
        <div className="absolute top-10 right-20 flex flex-col gap-1">
          <span className="capitalize">{auth?.currentUser?.displayName}</span>
          <span>{auth?.currentUser?.email}</span>
        </div>
        <img src="/img/new-home/banner-date.png" alt="" className="w-[400px]" />
        <h1 className="text-6xl">🎉</h1>
        <h1 className="font-semibold text-4xl capitalize">
          Congratulations {name}!
        </h1>
        <p className="font-semibold text-xl text-center w-1/2">
          You have completed the challenge. We will announce results on{" "}
          {resultDate} on parent's email ({auth.currentUser?.email}) and also on
          our website{" "}
          <a className="underline" href={website}>
            {website}
          </a>
        </p>
        <Button
          version="secondary"
          text=""
          className="px-10"
          handleClick={() => (window.location.href = "/")}
        >
          <span className="text-xl">Back to Website</span>
        </Button>

        {/* {showFeedbackView ? (
          <div className="w-full h-full z-20 absolute top-0 left-0">
            <ExamFeedback
              // dataSheetId={dataSheetId}
              closeClicked={() => setshowFeedbackView(false)}
              closeModule={closeFeedback}
              showSuccessDialog={showSuccessDialog}
              // uid={uid}
            />
          </div>
        ) : successDialog ? (
          <div className="w-full h-full z-20 absolute top-0 left-0 flex items-center justify-center">
            <SuccessFeedback
              closeSuccessModule={() => {
                setSuccessDialog(false);
              }}
              module="addFeedback"
              closeModule={closeFeedback}
            />
          </div>
        ) : (
          ""
        )} */}
      </div>
    </div>
  );
};

export default SubmitModule;
